import { render, staticRenderFns } from "./SeedsGet.vue?vue&type=template&id=1bac9c9e&"
import script from "./SeedsGet.vue?vue&type=script&lang=js&"
export * from "./SeedsGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bac9c9e')) {
      api.createRecord('1bac9c9e', component.options)
    } else {
      api.reload('1bac9c9e', component.options)
    }
    module.hot.accept("./SeedsGet.vue?vue&type=template&id=1bac9c9e&", function () {
      api.rerender('1bac9c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/Widgets/SeedsGet.vue"
export default component.exports